import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=dc0d296a&scoped=true"
import script from "./Text.vue?vue&type=script&lang=js"
export * from "./Text.vue?vue&type=script&lang=js"
import style0 from "./Text.vue?vue&type=style&index=0&id=dc0d296a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0d296a",
  null
  
)

export default component.exports